export default [
  '$state', '$rootScope', 'AuthService',
  class MyAccountCtrl {
    constructor($state, $rootScope, authService) {
      this._$state = $state;

      authService.getCurrentUser()
        .catch(() => $rootScope.$broadcast('login:open', { route: '/my-account', cancelRedirect: '/' }));
    }

    currentView() {
      if (this._$state.is('my-account.default-address'))
        return 'address';
      if (this._$state.is('my-account.payment-methods'))
        return 'payment';

      return 'orders';
    }

    selectTab(tab) {
      if (tab === 'address') {
        this._$state.go('my-account.default-address');
      } else if (tab === 'payment') {
        this._$state.go('my-account.payment-methods');
      } else {
        this._$state.go('my-account.order-history');
      }
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/pages/my-account/my-account.ctrl.js